import { FixedNumber } from '@ethersproject/bignumber'
import { ChainId, Token, Fetcher, Route, Trade, TokenAmount, TradeType, WETH } from '@overage69/pancake-sdk-v2'
import { getDefaultProvider } from '@ethersproject/providers'
import Web3 from 'web3'
const provider = getDefaultProvider('https://bsc-dataseed.binance.org/')
const web3 = new Web3('https://bsc-dataseed.binance.org/')
const addresses = {
  WBNB: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  BUSD: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
  USDT: '0x55d398326f99059fF775485246999027B3197955'
}
const [WBNB, USDT] = [addresses.WBNB, addresses.USDT].map(tokenAddress => new Token(ChainId.MAINNET, tokenAddress, 18))
const TOKEN_ADDRESS = '0xB7258450681f4aAd0ab24E336648d44A6696B30f'
const STE_TOKEN_ADDRESS = '0xA4CcaE9F2bD6195053D675e9a09B1d894695Ca0F'
import { BUSDToken, CHAIN_ID } from './bsc-helper'

export class PancakePriceHelper {
  tokenPriceBUSD?: any
  tokenSTEPrice?: any

  async getTokenPrice() {
    const token = this.createNewBep20Token(TOKEN_ADDRESS, 6)
    this.tokenPriceBUSD = await this.getBep20TokenPriceBUSD(token)
    const tokenSTE = this.createNewBep20Token(STE_TOKEN_ADDRESS, 18)
    this.tokenSTEPrice = await this.getBep20TokenPriceBUSD(tokenSTE)
  }

  createNewBep20Token(tokenAddress, tokenDecimals) {
    return new Token(ChainId.MAINNET, tokenAddress, tokenDecimals)
  }

  async getBep20TokenPriceBUSD(token) {
    const pair = await Fetcher.fetchPairData(token, USDT, provider)
    const route = new Route([pair], token)
    const amount = new TokenAmount(token, web3.utils.toBN(Math.pow(10, token.decimals)) as any)
    const trade = new Trade(route, amount, TradeType.EXACT_INPUT)
    return trade.executionPrice.toSignificant(18)
  }

  async bnb2Usd() {
    const pair = await Fetcher.fetchPairData(BUSDToken, WETH[CHAIN_ID], provider)
    const route = new Route([pair], BUSDToken)
    const value = new TokenAmount(BUSDToken, web3.utils.toWei(`1`))
    const trade = new Trade(route, value, TradeType.EXACT_INPUT)
    return trade.executionPrice.invert().toSignificant(6)
  }
}
export const priceHelper = new PancakePriceHelper()
